import type { UIEvent } from 'react';

export enum CTA_SHIPPING_MODEL_CONST {
  TEST_ID = 'cta-shipping-model',
}

export interface ShippingModelCtaProps {
  buttonLabel: string;
  disabled: boolean;
  onClick: (event: UIEvent<HTMLButtonElement>) => void;
}
